import { Modal } from 'components/molecules/Modal'
import type { LoginModalProps } from './types'
import { openModal, closeModal, cn, getError } from 'lib/utils'
import { EModalType } from './enums'
import {
  Button,
  EButtonVariant,
  EButtonStyleVariant,
} from 'components/atoms/Button'
import { Input } from 'components/atoms/Input'
import { PasswordInput } from 'components/atoms/PasswordInput'
import { FormError } from 'components/atoms/FormError'
import { useSignInForm } from './hooks'

const mainClass = 'form'

export const LoginModal = ({
  title,
  submitButton,
  resetLink,
  signUpLink,
  or,
}: LoginModalProps) => {
  const { formRef, isSubmitting, errors, handleSubmit } = useSignInForm()

  const handleResetClick = (e: React.MouseEvent) => {
    e.preventDefault()
    openModal(EModalType.RESET)
  }

  const handleSignupClick = (e: React.MouseEvent) => {
    e.preventDefault()
    openModal(EModalType.SIGN_UP)
  }

  return (
    <Modal title={title} onClose={closeModal}>
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className={cn(mainClass, `${mainClass}--login`)}
      >
        <FormError message={getError(errors, 'error')} />
        <Input
          name="email"
          type="email"
          id="email"
          placeholder="Email *"
          error={getError(errors, 'email')}
        />
        <PasswordInput
          name="password"
          autoComplete="off"
          placeholder="Password *"
          id="password"
          error={getError(errors, 'password')}
        />
        <Input
          name="otp_attempt"
          type="text"
          autoComplete="off"
          placeholder="Authentication code *"
          id="otp_attempt"
          error={getError(errors, 'otp_attempt')}
        />
        <Button
          type="submit"
          variant={EButtonVariant.BUTTON}
          buttonVariant={EButtonStyleVariant.PRIMARY}
          disabled={isSubmitting}
        >
          {submitButton}
        </Button>
        <div className={`${mainClass}__footer`}>
          <div>
            <a href="#" role="button" onClick={handleResetClick}>
              {resetLink}
            </a>{' '}
            {or}{' '}
            <a href="#" role="button" onClick={handleSignupClick}>
              {signUpLink}
            </a>
          </div>
        </div>
      </form>
    </Modal>
  )
}
